const getEnv = (key: string, fallback = ''): string => {
  if (typeof import.meta === 'undefined' || !import.meta.env) {
    return fallback
  }
  const value = import.meta.env[key as keyof ImportMetaEnv]
  return (value as string | undefined) ?? fallback
}

export const API_CONFIG = {
  baseUrl: getEnv('VITE_API_BASE_URL', 'http://localhost:8000'),
  useMockApi: false, // Always use real API - mock data removed
  bootstrapAdminEmail: getEnv('VITE_BOOTSTRAP_SUPER_ADMIN_EMAIL', ''),
  bootstrapAdminPassword: getEnv('VITE_BOOTSTRAP_SUPER_ADMIN_PASSWORD', ''),
}

export const STORAGE_KEYS = {
  authToken: 'iris_ui_auth_token',
  refreshToken: 'iris_ui_refresh_token',
  users: 'iris_ui_users_store',
}


